var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex items-center gap-x-2 rounded-sm bg-ink-300 px-4 py-3 text-sm text-vanilla-400"},[_vm._t("indicator",function(){return [_c('span',{staticClass:"h-2 w-2 flex-shrink-0 rounded-full",class:[_vm.enabled ? 'bg-juniper' : 'bg-slate']})]}),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }